import React from "react";

import { cx } from "~/tools/class-variance";

export const LabelBullet: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
	<div {...props} className={cx("h-1 w-4 flex-none rounded-px", className)} />
);
